// incomesReport.jsx
import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  Stack,
  MenuItem,
} from "@mui/material";
import { useSucursales } from "../../../Services/Sucursales";
import { useReportes } from "../../../Services/Reportes";
import { buttonGuardar, Input, TituloColor } from "../../../Layouts/CustomStyles";

const IncomesReport = () => {
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [formData, setFormData] = useState({
    branch_id: "",
    format: "pdf", // Nuevo campo para el formato
  });

  const [sucursales, setSucursales] = useState([]);
  const [loading, setLoading] = useState(false);

  const { getSucursales } = useSucursales();
  const { getReporteIngreso } = useReportes(); // 👈 importar servicio de reportes

  const months = [
    { value: "01", label: "Enero" },
    { value: "02", label: "Febrero" },
    { value: "03", label: "Marzo" },
    { value: "04", label: "Abril" },
    { value: "05", label: "Mayo" },
    { value: "06", label: "Junio" },
    { value: "07", label: "Julio" },
    { value: "08", label: "Agosto" },
    { value: "09", label: "Septiembre" },
    { value: "10", label: "Octubre" },
    { value: "11", label: "Noviembre" },
    { value: "12", label: "Diciembre" },
  ];

  const formats = [
    { value: "pdf", label: "PDF" },
    { value: "excel", label: "Excel" },
  ];

  const fetchData = async () => {
    try {
      setLoading(true);
      const data = await getSucursales();
      setSucursales(data);
    } catch (err) {
      console.error(err.message || "Error al cargar sucursales");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

const handleDownload = async (e) => {
    e.preventDefault();
    if (!month || !year) {
      alert("Por favor, selecciona mes y año.");
      return;
    }

    try {
      setLoading(true);

      // Parámetros para el backend
      const params = {
        month,
        year,
        branch_id: formData.branch_id || null,
        format: formData.format, // Enviar formato
      };

      const response = await getReporteIngreso(params);

      // Manejar el archivo blob (PDF o Excel)
      if (response instanceof Blob) {
        const url = window.URL.createObjectURL(response);
        const a = document.createElement("a");
        a.href = url;
        const extension = formData.format === "excel" ? "xlsx" : "pdf";
        a.download = `reporte_ingresos_${month}_${year}.${extension}`;
        a.click();
        window.URL.revokeObjectURL(url);
      } else {
        console.log("Respuesta:", response);
      }
    } catch (err) {
      alert(err.message || "Error al descargar el reporte");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper
      elevation={3}
      sx={{
        maxWidth: 400,
        mx: "auto",
        mt: 5,
        p: 4,
        borderRadius: 3,
      }}
    >
      <Typography
        variant="h6"
        gutterBottom
       sx={TituloColor}
        textAlign="center"
      >
        Reporte de Ingresos
      </Typography>
      <Box component="form" onSubmit={handleDownload}>
        <Stack spacing={3}>
          {/* Mes */}
          <TextField
            select
            label="Mes"
            value={month}
            sx={Input}
            onChange={(e) => setMonth(e.target.value)}
            required
            fullWidth
          >
            {months.map((m) => (
              <MenuItem key={m.value} value={m.value}>
                {m.label}
              </MenuItem>
            ))}
          </TextField>

          {/* Año */}
          <TextField
            label="Año"
            type="number"
            sx={Input}
            value={year}
            onChange={(e) => setYear(e.target.value)}
            required
            inputProps={{ min: 2000, max: 2100 }}
            fullWidth
          />

          {/* Sucursal */}
          <TextField
            select
            fullWidth
            label="Sucursal (opcional)"
            name="branch_id"
            sx={Input}
            value={formData.branch_id}
            onChange={(e) =>
              setFormData({ ...formData, branch_id: e.target.value })
            }
          >
            {sucursales.length > 0 ? (
              sucursales.map((sucursal) => (
                <MenuItem key={sucursal.id} value={sucursal.id}>
                  {sucursal.name}
                </MenuItem>
              ))
            ) : (
              <MenuItem disabled>No hay sucursales disponibles</MenuItem>
            )}
          </TextField>

          {/* Formato */}
          <TextField
            select
            fullWidth
            label="Formato"
            sx={Input}
            name="format"
            value={formData.format}
            onChange={(e) =>
              setFormData({ ...formData, format: e.target.value })
            }
            required
          >
            {formats.map((f) => (
              <MenuItem key={f.value} value={f.value}>
                {f.label}
              </MenuItem>
            ))}
          </TextField>

          {/* Botón */}
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={loading}
            sx={buttonGuardar}
          >
            {loading ? "Descargando..." : "Descargar"}
          </Button>
        </Stack>
      </Box>
    </Paper>
  );
};

export default IncomesReport;
